<div class="cmx-table-header" [class.--scroll-spacing]="tableHasScroll">
    <ng-container headerPlaceholder></ng-container>
</div>
<div #cmxTableBody class="cmx-table-body">
    <ng-container rowPlaceholder></ng-container>
</div>
<div *ngIf="pages.length > 1" style="text-align: center;">
    <cmx-pagination [pages]="pages.length" [currentPage]="currentActivePage"
    (pageChanged)="setCurrentPage($event)"></cmx-pagination>
</div>